import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import Typography from 'src/common/components/Typography';
import AddonIcon from 'src/addons/components/AddonIcon';
import { type ListingAddon } from 'src/common/types/common/Addons';
import { formatAddonPrice } from 'src/addons/utils/helpers';
import styles from './ListingOptionalAddons.module.scss';

export type ListingOptionalAddonsProps = {
  listingAddons: ListingAddon[];
};

const ListingOptionalAddons: FC<ListingOptionalAddonsProps> = ({
  listingAddons,
}) => {
  const [t] = useTranslation('common');

  return (
    <div className={styles.root}>
      <div className={styles.title}>
        <Typography
          size="body-xl"
          weight="semibold"
          type="h3"
        >
          {t('addons--optional-title')}
        </Typography>
        <Typography
          size="body-s"
          weight="regular"
          type="p"
        >
          {t('addons--optional-description')}
        </Typography>
      </div>
      <div className={styles.cards}>
        {listingAddons.map((addon) => (
          <div className={styles.card} key={addon.id}>
            <AddonIcon
              iconName={addon.icon_name}
              subType={addon.sub_type}
              size="small"
            />
            <div className={styles.text}>
              <div className={styles.title}>
                <Typography
                  size="body-s"
                  weight="semibold"
                  type="p"
                >
                  {addon.title}
                </Typography>
              </div>
              <div className={styles.price}>
                <Typography
                  size="body-s"
                  type="p"
                >
                  {formatAddonPrice(addon, t).formatted}
                </Typography>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ListingOptionalAddons;
